import axios from 'axios'

export default async ()=>{
    try {
        //
        let response = await axios.get(
            process.env.VUE_APP_API_ROUTE + '/wh_product/suggest_upc_code'
        )

        //
        return response.data
    } catch (error) {
        //
        //console.log( error )

        //
        return error.response.data
    }
}